import * as  Yup from "yup";

const IndividualPlanSchema = Yup.object().shape({
   individualPlan: Yup
        .string()
        .required("Обов'язкове поле"),
});
export default IndividualPlanSchema;
